<template>
  <div>
    <Drawer
      title="编辑镜像"
      v-model="changeModal"
      width="720"
      :mask-closable="true">
      <Form :model="changeForm" ref="changeForm" :rules="changeRule" :label-width="90" label-position="right">
        <FormItem prop="name" label="镜像名称">
          <Input v-model="changeForm.name" style="width: 250px" />
        </FormItem>
        <FormItem prop="min_disk" label="最小磁盘要求">
          <InputNumber :min="0" v-model="changeForm.min_disk"></InputNumber><span> (GB)</span>
        </FormItem>
        <FormItem prop="min_ram" label="最低内存要求">
          <InputNumber :min="0" v-model="changeForm.min_ram"></InputNumber><span> (MB)</span>
        </FormItem>
        <FormItem prop="visibility" label="可见性">
          <RadioGroup v-model="changeForm.visibility" type="button">
            <Radio label="public">公有</Radio>
            <Radio label="private">私有</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="protected" label="受保护的">
          <i-switch v-model="changeForm.protected">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
          <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <VolumeEdit ref="VolumeEdit" v-on:editComplete="$router.push({ name: 'volumes' })"></VolumeEdit>
    <Card shadow style="border-radius: unset">
      <a style="margin-right: 24px" v-on:click="back">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      <h3 style="color: #171d25; display: inline-block;">{{ info.name }}</h3>
      <div style="float: right">
        <Button type="primary" size="small" @click="$router.push({name: 'private_cloud_fast_create_server', query: {defaultImage: info.id}})">启动实例</Button>
        <Button type="info" size="small" :style="{marginLeft: '5px'}" @click="$refs.VolumeEdit.openModal('image', info)">创建云硬盘</Button>
        <Button type="warning" size="small" :style="{marginLeft: '5px'}" @click="changeModal = true">编辑镜像</Button>
        <!--<Button type="warning" size="small" :style="{marginLeft: '5px'}">更新元数据</Button>-->
        <Button type="error" size="small" icon="md-trash" :style="{marginLeft: '5px'}" @click="deleteImage">删除镜像</Button>
      </div>
    </Card>
    <div class="private-cloud-resource-detail-content">
      <div class="main">
        <div>
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="info-property">
                <div class="resource-content-title">
                  <h4>镜像</h4>
                </div>
                <dl>
                  <dt>名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>ID</dt><dd>{{ info.id }}</dd>
                </dl>
                <dl>
                  <dt>状态</dt>
                  <dd v-if="info.status === 'queued'">队列中</dd>
                  <dd v-else-if="info.status === 'active'">可用</dd>
                  <dd v-else-if="info.status === 'saving'">保存中</dd>
                  <dd v-else-if="info.status === 'uploading'">上传中</dd>
                  <dd v-else-if="info.status === 'importing'">导入中</dd>
                  <dd v-else-if="info.status === 'deleted'">已删除</dd>
                  <dd v-else-if="info.status === 'pending_delete'">待删除</dd>
                  <dd v-else-if="info.status === 'deactivated'">停用</dd>
                  <dd v-else-if="info.status === 'killed'">错误</dd>
                  <dd v-else>{{ info.status }}</dd>
                </dl>
                <dl>
                  <dt>大小</dt>
                  <dd>{{ imageSize }}</dd>
                </dl>
                <dl>
                  <dt>最小磁盘大小</dt><dd>{{info.min_disk}} GB</dd>
                </dl>
                <dl>
                  <dt>最小内存</dt><dd>{{info.min_ram}} MB</dd>
                </dl>
                <dl>
                  <dt>磁盘格式</dt><dd>{{info.disk_format}}</dd>
                </dl>
                <dl>
                  <dt>容器格式</dt><dd>{{info.container_format}}</dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl>
                  <dt>更新时间</dt><dd v-if="info.updated_at">{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
              </div>
              <div class="info-property">
                <div class="resource-content-title">
                  <h4>定制属性</h4>
                </div>
                <dl>
                  <dt>File</dt>
                  <dd>{{info.file}}</dd>
                </dl>
                <dl>
                  <dt>Schema</dt>
                  <dd>
                    {{info.schema}}
                  </dd>
                </dl>
                <dl>
                  <dt>标签</dt>
                  <dd>
                    <span v-bind:key="index" v-for="(item, index) in info.tags">{{ item }} </span>
                  </dd>
                </dl>
                <dl>
                  <dt>虚拟大小</dt>
                  <dd>
                    {{ info.virtual_size }}
                  </dd>
                </dl>
              </div>
              <div class="info-property">
                <div class="resource-content-title">
                  <h4>安全</h4>
                </div>
                <dl>
                  <dt>可见性</dt>
                  <dd>
                    <span v-if="info.visibility === 'public'">公有</span>
                    <span v-else-if="info.visibility === 'private'">私有</span>
                    <span v-else-if="info.visibility === 'shared'">共享的</span>
                    <span v-else>{{ info.visibility }}</span>
                  </dd>
                </dl>
                <dl>
                  <dt>受保护的</dt>
                  <dd>
                    <span v-if="info.protected === true">是</span>
                    <span v-if="info.protected === false">否</span>
                  </dd>
                </dl>
                <dl>
                  <dt>校验和</dt>
                  <dd>{{ info.checksum }}</dd>
                </dl>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { detailPrivateCloudImage, changePrivateCloudImage, deletePrivateCloudImage } from '@/api/private-cloud/image'
import moment from 'moment'
import VolumeEdit from '../storage/components/volume-edit'

export default {
  name: 'image-detail',
  components: {
    VolumeEdit
  },
  data () {
    return {
      info: {},
      imageSize: '',
      changeModal: false,
      moment: moment,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        min_disk: 0,
        min_ram: 0,
        visibility: 'public',
        protected: false
      },
      changeRule: {
        name: [
          {required: true, message: '镜像名称不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  mounted: function () {
    this.init()
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.getDetail()
    },
    // 获取镜像详细信息
    getDetail () {
      detailPrivateCloudImage(this.$route.params.id).then(res => {
        this.info = res.data
        this.changeForm.id = this.info.id
        this.changeForm.name = this.info.name
        this.changeForm.min_disk = this.info.min_disk
        this.changeForm.min_ram = this.info.min_ram
        this.changeForm.visibility = this.info.visibility
        this.changeForm.protected = this.info.protected
        let size = res.data.size
        if (size) {
          const KB = 1024
          const MB = KB * 1024
          const GB = MB * 1024
          if (size >= GB) {
            this.imageSize = (size / GB).toFixed(2) + ' GB'
          } else if (size >= MB) {
            this.imageSize = (size / MB).toFixed(2) + ' MB'
          } else if (size >= KB) {
            this.imageSize = (size / KB).toFixed(2) + ' KB'
          } else {
            this.imageSize = size + ' 字节'
          }
        }
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '获取镜像数据失败',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取镜像数据失败！'
          })
        }
      })
    },
    // 删除镜像
    deleteImage () {
      if (!this.info.protected) {
        this.$Modal.confirm({
          title: '删除',
          content: '确定要删除此镜像吗？',
          onOk: () => {
            deletePrivateCloudImage(this.$route.params.id).then(res => {
              this.$Notice.success({title: '操作成功！'})
              this.init()
            }).catch(res => {
              if (res.request) {
                this.$Notice.error({
                  title: '操作失败！ 错误状态码:' + res.request.status,
                  desc: res.request.responseText
                })
              } else {
                this.$Notice.error({
                  title: '操作失败！服务器无响应'
                })
              }
            })
          }
        })
      } else {
        this.$Notice.error({
          title: '该镜像是受保护的, 不能删除！'
        })
      }
    },
    // 编辑提交
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          changePrivateCloudImage(this.changeForm, this.$route.params.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.init()
            this.changeLoading = false
            this.changeModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    // 返回上一页
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less">
  @import './../base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .logs-scroll-bar {
    height: 750px;
  }
</style>
